/* eslint-disable no-extend-native */
import { useSelector } from "react-redux";
import styled from "styled-components";
import { Header } from "../components/Header";
import { Learn } from "../components/Learn";
import { QuickActions } from "../components/QuickActions";
import { RecentWork } from "../components/recentWork/RecentWork";

export default function Home() {
	const { userInfo } = useSelector((state) => state.auth);
	const isReadOnly = userInfo.UserType?.isReadOnly();

	return (
		<MainContainer className="container">
			<Body>
				<Header />
				{!isReadOnly && <QuickActions />}
				<RecentWork />
				<Learn />
			</Body>
		</MainContainer>
	);
}

const MainContainer = styled.div`
	width: 1200px;
	margin-top: 24px;
    padding: 0px !important;
`;

const Body = styled.div`
	display: flex;
	flex-direction: column;
	height: inherit;
`;
